import MainStores from './MainStores';

export default MainStores;
